import { CountryCode, format, isValidNumber, NationalNumber, ParsedNumber, parseNumber } from 'libphonenumber-js';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

export const parsePhoneNumber = (phoneValue: string): ParsedNumber => {
  const parsedNumber = parseNumber(phoneValue, {
    defaultCountry: 'US',
  }) as ParsedNumber;
  return parsedNumber;
};

export const formatAsReadonlyPhone = (parsedNumber: ParsedNumber): string => {
  if (parsedNumber.phone === '') {
    return '';
  }
  const internationalNumber = format(parsedNumber, 'INTERNATIONAL');
  return internationalNumber;
};

export const formatAsRFC3966Phone = (parsedNumber: ParsedNumber): string => {
  if (!parsedNumber.phone) {
    return '';
  }
  return format(parsedNumber, 'RFC3966');
};

const validatePhone = (phone: NationalNumber, country: CountryCode): ValidationErrors | null => {
  const isInvalid = !isValidNumber(phone, country);
  if (isInvalid) {
    return {
      invalidPhoneNumber: true,
    };
  }
  const cannotParse = !Object.keys(parsePhoneNumber(formatAsRFC3966Phone({ phone, country }))).length;
  if (cannotParse) {
    return {
      invalidPhoneNumber: true,
    };
  }
  return null;
};

export const validatePhoneNumber = (control: AbstractControl): ValidationErrors | null => {
  const parsedPhoneNumber = {
    country: control.value.country,
    phone: control.value.phoneNumber,
    ext: control.value.extension,
  } as ParsedNumber;
  if (!parsedPhoneNumber.phone) {
    return null;
  }
  return validatePhone(parsedPhoneNumber.phone, parsedPhoneNumber.country);
};

export const validateBasedOnPhoneFormGroup = (phoneGroup: FormGroup) => (): ValidationErrors | null => {
  phoneGroup.updateValueAndValidity();
  if (phoneGroup.invalid) {
    return {
      invalidPhoneNumber: true,
    };
  }
  return null;
};
